/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Meta_DescriptionInputs */

const en_login_page_meta_description = /** @type {(inputs: Login_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to Glider with email, Google, or a connected wallet.`)
};

const de_login_page_meta_description = /** @type {(inputs: Login_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden Sie sich bei Glider per E-Mail, Google oder einer verbundenen Wallet an.`)
};

const pt_br2_login_page_meta_description = /** @type {(inputs: Login_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre na Glider com e-mail, Google ou uma carteira conectada.`)
};

const tr_login_page_meta_description = /** @type {(inputs: Login_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta, Google veya bağlı bir cüzdanla Glider'a giriş yapın.`)
};

const zh_cn2_login_page_meta_description = /** @type {(inputs: Login_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用电子邮件、Google 或已连接的钱包登录 Glider。`)
};

const zh_hk2_login_page_meta_description = /** @type {(inputs: Login_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用電郵、Google 或已連接的錢包登入 Glider。`)
};

const ko_kr2_login_page_meta_description = /** @type {(inputs: Login_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일, Google 또는 연결된 지갑으로 Glider에 로그인하세요.`)
};

const ru_ru2_login_page_meta_description = /** @type {(inputs: Login_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите в Glider с помощью электронной почты, Google или подключённого кошелька.`)
};

const es_419_login_page_meta_description = /** @type {(inputs: Login_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión en Glider con correo electrónico, Google o una billetera conectada.`)
};

/**
* | output |
* | --- |
* | "Sign in to Glider with email, Google, or a connected wallet." |
*
* @param {Login_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_meta_description = /** @type {((inputs?: Login_Page_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Meta_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_meta_description(inputs)
	if (locale === "de") return de_login_page_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_meta_description(inputs)
	if (locale === "tr") return tr_login_page_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_meta_description(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_meta_description(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_meta_description(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_meta_description(inputs)
	return es_419_login_page_meta_description(inputs)
});